import { useEffect, useRef } from "react";
import { BrandLogo } from "@/components/BrandLogo";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Exchanges the one-time Google session_id (URL fragment) for our session cookies, then opens the app.
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setSession } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    api.post("/auth/google/session", { session_id: sessionId })
      .then((r) => { setSession(r.data); navigate("/", { replace: true, state: { user: r.data } }); })
      .catch(() => { setSession(false); navigate("/login?google=failed", { replace: true }); });
  }, [location.hash, navigate, setSession]);

  return (
    <div data-testid="auth-callback" className="min-h-screen flex flex-col items-center justify-center gap-4 court-grain">
      <BrandLogo />
      <p className="text-sm text-slate-400 animate-pulse">Signing you in with Google…</p>
    </div>
  );
}
